<script setup>
  import {inject, onBeforeMount, ref, watch} from "vue";

  defineOptions({name: "ComponentTab"});

  defineProps({
    title: {
      type: String,
      default: "",
    },
    infoMessage: {
      type: [Number, String],
      default: "",
    },
  });

  const tabs = inject("tabsProvider", {
    selectedIndex: 0,
    count: 0,
  });

  const index = ref(0);
  const isActive = ref(true);

  onBeforeMount(() => {
    index.value = tabs.count;
    tabs.count++;
    isActive.value = index.value === tabs.selectedIndex;
  });

  watch(
    () => tabs.selectedIndex,
    () => {
      isActive.value = index.value === tabs.selectedIndex;
    },
  );
</script>

<template lang="html">
  <div v-show="isActive">
    <slot :is-active="isActive" />
  </div>
</template>
